import { render } from "./SecondaryBtn.vue?vue&type=template&id=01464117&scoped=true"
import script from "./SecondaryBtn.vue?vue&type=script&lang=js"
export * from "./SecondaryBtn.vue?vue&type=script&lang=js"

import "./SecondaryBtn.vue?vue&type=style&index=0&id=01464117&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-01464117"

export default script